















































import Vue from 'vue';
import CtrlDialog from '@/components/common/control/CtrlDialog.vue';
// #897421 OutStatus対応
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
// #897421
import axios from '@/plugins/axios';
import { API_SEARCH_LIST_KOJO_HIMMOKU } from '@/constants/api';
import { BUTTON } from '@/constants/label';
// #897421 OutStatus対応
import { OutStatus } from '@/constants/constants';
// #897421

export default Vue.extend({
  name: 'ListKojoHimmoku',
  // #897421 OutStatus対応
  // components: { CtrlDialog },
  components: { CtrlDialog, CtrlMessageDialog },
  // #897421
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    getKojoHimmoku: {
      type: Function,
    },
    shiiresakiCd: {
      type: Number,
      required: true,
    },
    gyoshuCd: {
      type: Number,
      required: true,
    },
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    BUTTON: BUTTON,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'checked',
        width: 56,
      },
      {
        text: 'コード',
        sortable: true,
        value: 'himmokuCd',
        width: 101,
      },
      {
        text: '品目',
        sortable: true,
        value: 'himmokuRyakuMei',
        width: 457,
      },
    ],
    items: [],
    // #897421 OutStatus対応
    wMessage: false,
    wMessageId: '',
    wMessageTextParam: [] as string[],
    // #897421
  }),

  methods: {
    // #897421 OutStatus対応
    // response error の場合の message dialog で OK click
    handleWarnExit() {
      this.wMessage = false;
      this.wMessageId = '';
      this.wMessageTextParam = [];
    },
    // #897421
    callbackOk() {
      const checkedItems = this.items.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => item.checked === true
      );
      if (checkedItems.length > 0) {
        this.getKojoHimmoku(checkedItems);
        this.$emit('update:show', false);
      }
    },
  },

  created() {
    const params = {
      shiiresakiCd: this.shiiresakiCd,
      gyoshuCd: this.gyoshuCd,
    };

    this.initialDataSearch &&
      axios
        .get(API_SEARCH_LIST_KOJO_HIMMOKU, { params })
        .then((res) => {
          // #897421 OutStatus対応
          if (
            res &&
            res.status == 200 &&
            res.data &&
            res.data.error &&
            res.data.error.outStatus &&
            res.data.error.outStatus != OutStatus.NORMAL
          ) {
            this.wMessageId = res.data.error.messageID;
            this.wMessageTextParam = res.data.error.messageArgs;
            this.wMessage = true;
            // 一覧をクリア
            this.items = [];
            return;
          }
          // #897421
          this.items = res.data.responseData;
        })
        .catch((err) => {
          console.log(err.response);
        });
  },
});
